import { Injectable } from '@angular/core';
import {ServerService} from "../../../services/ServerService";
import {HttpClient} from "@angular/common/http";

@Injectable({
  providedIn: 'root'
})
export class FiscalService extends ServerService {

  constructor(http: HttpClient) {
    super(http);
  }

  listeOrigens() {
    return this.obtenha('/nfce/origens', {});
  }

  listeCfopsNfce() {
    return this.obtenha('/nfce/cfops', {});
  }

  listeRegimesTributarios() {
    return this.obtenha('/nfce/regimesTributarios', {});
  }

  listeTiposDeTributacao() {
    return this.obtenha('/nfce/tiposDeTributacaoICMS', {});
  }

  listeModalidadesBCICMS() {
    return this.obtenha('/nfce/modalidadesBCICMS', {});
  }

  listeModalidadesBCICMSST() {
    return this.obtenha('/nfce/modalidadesBCICMSST', {});
  }

  salveConfiguracoesFiscais(produto, configuracaoFiscal) {
    return this.salve('/nfce/produto/configuracoes', {idProduto: produto.id, configuracaoFiscal: configuracaoFiscal});
  }

  listeTiposDeTributacaoIPI() {
    return this.obtenha('/nfce/tiposDeTributacaoIPI', {});
  }

  listeSelosDeControleIPI() {
    return this.obtenha('/nfce/selosDeControleIPI', {});
  }

  listeNcms(q: string = '', codigo: string = '', limit: number = 80) {
    return this.obtenha('/nfce/ncms', { q, codigo, limit });
  }

  listeCests(ncm: string = '', q: string = '', codigo: string = '', limit: number = 80) {
    return this.obtenha('/nfce/cests', { ncm, q, codigo, limit });
  }

  /**
   * Emite uma NFC-e para um pedido específico
   * @param idPedido ID do pedido para o qual a NFC-e será emitida
   * @returns Promise com o resultado da emissão
   */
  emitaNfcePedido(idPedido: number) {
    return this.salve('/nfce/emitir', { idPedido });
  }

  emitaNfceComanda(idComanda: number) {
    return this.salve('/nfce/emitirComanda', { idComanda });

  }
}
